/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeRoleListCtrl
 */
angular.module('mercury.modules.time.role')
.controller('TimeRoleListCtrl', ["$uibModal", "$resource", "$scope", "title", "settings", function($uibModal, $resource, $scope, title, settings) {
  title.set('Manage Roles');
  var Roles = $resource(settings.mercHost + '/staff-roles/:id', {id: '@id'});

  $scope.showDeleted = false;
  $scope.errorMessage = null;

  var modalInstance;

  $scope.costGroupingOptions = [
    {label: 'Food', value: 'f'},
    {label: 'Beverage', value: 'b'}
  ];

  $scope.roles = Roles.query();

  $scope.matchesFilter = function(role) {
    return (role.datestampDeleted !== null) == $scope.showDeleted;
  };

  $scope.addRoleDialog = function() {
    $scope.errorMessage = null;

    $scope.editModel = new Roles({
    });

    modalInstance = $uibModal.open({
      scope: $scope,
      templateUrl: 'modules/time/role/edit.tpl.html'
    });

    modalInstance.result.then(function(newRole) {
      $scope.roles.unshift(newRole);
    });
  };

  $scope.editRoleDialog = function(index) {
    $scope.errorMessage = null;

    $scope.editModel = angular.copy($scope.roles[index]);

    modalInstance = $uibModal.open({
      scope: $scope,
      templateUrl: 'modules/time/role/edit.tpl.html'
    });

    modalInstance.result.then(function(updatedRole) {
      $scope.roles.splice(index, 1, updatedRole);
    });
  };

  /**
  * Callback for save button on role editor. POST editModel to the server to update the role
  * and splice the changed role into the roles model.
  */
  $scope.saveRole = function() {
    $scope.editModel.$update(function() {
      modalInstance.close($scope.editModel);
    });
  };

  /**
  * Callback for the create button on the role editor. POST editModel to the server to add the role
  * and prepend the role to the roles model
  */
  $scope.createRole = function() {
    $scope.editModel.$save(function() {
      modalInstance.close($scope.editModel);
    });
  };
  /**
  * Callback for the delete button on the role editor. Set the whendeleted field on the role and POST the
  * changes to the server.
  */
  $scope.deleteRole = function() {
    $scope.editModel.datestampDeleted = moment().format();

    $scope.editModel.$update(function() {
      modalInstance.close($scope.editModel);
    });
  };

  /**
  * Callback for the Restore Role option in the roles actions menu. Set the whendeleted field to null and POST
  * the updated role to the server.
  */
  $scope.undeleteRole = function(role) {
    role.datestampDeleted = null;
    role.$update();
  };
}]);
